'use strict';

var FirebaseIndirectArray = require('./FirebaseIndirectArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeController = require('./KayleeController');
var KayleeUtil = require('./KayleeUtil');
//var log = require('../log/Log').channel('KayleeControllers');

var KayleeControllers = {
    fromJson: fromJson,
    getControllers: getControllers,
};

function fromJson(data) {
    var reqProps = [ '$roomId' ];
    return FirebaseIndirectArray.$fromJson(data, 'Controllers', reqProps, reqProps,
        function(data) {
            var room = KayleeCache.get('Room: ' + data.$roomId);
            return getControllers(room);
        }
    );
}

function getControllers(room) {
    var key = 'Controllers: ' + room.$id;
    var controllers = KayleeCache.get(key);

    if (controllers === null) {
        controllers = new Controllers(room);
        KayleeCache.put(key, controllers);
    }

    return controllers;
}

function Controllers(room) {
    this.$nodeType = 'controllers';
    this.$room = room;

    var srcRef = KayleeBase.app.database()
        .ref('index/controllersByRoom/' + room.$id);

    FirebaseIndirectArray.call(this, srcRef, KayleeController.getController);
    KayleeUtil.bindPrototypeMethods(Controllers.prototype, this, this.$items);
    this.$items.$self = this;
    return this.$items;
}

Controllers.prototype = Object.create(FirebaseIndirectArray.prototype);
Controllers.prototype.constructor = Controllers;

Controllers.prototype.$toJson = function() {
    return FirebaseIndirectArray.prototype.$toJson.call(this,
        [], { $roomId: this.$room.$id });
};

Controllers.prototype.toString = function() {
    return '[Controllers for ' + this.$room + ']';
};

module.exports = KayleeControllers;








